/**
 * Mirrors the server-side rule in `Common/LinkBuilder.SafeReturnPath`.
 *
 * A `returnUrl` arrives from the query string, so it is attacker-controlled: without
 * this guard a crafted sign-in link would bounce the user to an external site that
 * looks like a continuation of the flow. Only a single-slash, same-origin path is
 * accepted; anything else falls back to the default landing page.
 */
export function safeReturnPath(raw: string | null | undefined, fallback = "/dashboard"): string {
  if (!raw) return fallback;

  const trimmed = raw.trim();

  // "//evil.com" and "/\evil.com" are protocol-relative and leave the origin.
  if (!trimmed.startsWith("/") || trimmed.startsWith("//") || trimmed.startsWith("/\\")) {
    return fallback;
  }

  // A control character can be used to smuggle a scheme past the checks above.
  // eslint-disable-next-line no-control-regex -- deliberately matches C0/C1 control characters.
  if (/[\u0000-\u001f\u007f]/.test(trimmed)) return fallback;

  return trimmed;
}
